export const cancellationOptions = [
    {label: "Less than 24 hours", value: "Less than 24 hours", order: 1},
    {label: "Less than 48 hours", value: "Less than 48 hours", order: 2},
    {label: "Less than 7 days", value: "Less than 7 days", order: 3},
];

export const allClassTypeOptions = [
    // ONLINE ONLY
    {
        label: "Online Classes",
        value: "online_private",
        online_type: "online",
        type_of_class: "Private classes",
    },
    // {
    //   label: "Online Group Classes",
    //   value: "online_group",
    //   online_type: "online",
    //   type_of_class: "Group classes",
    // },
    // {
    //   label: "Online Private and Group Classes",
    //   value: "online_both",
    //   online_type: "online",
    //   type_of_class: "Private and Group classes",
    // },

    // OFFLINE ONLY
    {
        label: "Private Classes (in-person)",
        value: "offline_private",
        online_type: "offline",
        type_of_class: "Private classes",
    },
    {
        label: "Group Classes (in-person)",
        value: "offline_group",
        online_type: "offline",
        type_of_class: "Group classes",
    },
    {
        label: "Private and Group Classes (in-person)",
        value: "offline_both",
        online_type: "offline",
        type_of_class: "Private and Group classes",
    },

    // BOTH
    {
        label: "Private (in-person) and Online Classes",
        value: "both_private",
        online_type: "both",
        type_of_class: "Private classes",
    },
    {
        label: "Group (in-person) and Online Classes",
        value: "both_group",
        online_type: "both",
        type_of_class: "Group classes",
    },
    {
        label: "Private, Group (in-person) and Online Clases",
        value: "both_both",
        online_type: "both",
        type_of_class: "Private and Group classes",
    },
];

// Availability Classes

export const allAvailabilityClassTypeOptions = [
    // ONLINE ONLY
    {
        label: "Online Classes",
        value: "online_private",
        online_type: "online",
        type_of_class: "Private",
    },

    // OFFLINE ONLY
    {
        label: "Private Classes (in-person)",
        value: "offline_private",
        online_type: "offline",
        type_of_class: "Private",
    },
    {
        label: "Group Classes (in-person)",
        value: "offline_group",
        online_type: "offline",
        type_of_class: "Group",
    },

    // BOTH
    {
        label: "Private (in-person) and Online Classes",
        value: "both_private",
        online_type: "both",
        type_of_class: "Private",
    },
    {
        label: "Group (in-person) and Online Classes",
        value: "both_group",
        online_type: "both",
        type_of_class: "Group",
    },
];

export const inPersonClasses = [
    {
        label: "Private class",
        value: "Private",
    },
    {
        label: "Group class",
        value: "Group",
    },
];

export const onlineClasses = [
    {
        label: "Online class",
        value: "Online",
    },
];

export const isPrivateTypeClass = (selectedValue) => {
    return selectedValue?.toLowerCase().includes("private");
};

export const isGroupTypeClass = (selectedValue) => {
    return selectedValue?.toLowerCase().includes("group");
};

export const isOnlineTypeClass = (selectedValue, onlineType) => {
    // return onlineType === "both" || onlineType ==="online"
    return selectedValue?.toLowerCase().includes("online");
};

export const getAvailabilityOptions = (classType, onlineType) => {
    let classes = [];
    if (classType === privateGroup) {
        classes.push({
            label: "Private class",
            value: "Private",
        });
    }

    if (classType === group) {
        classes.push({
            label: "Group class",
            value: "Group",
        });
    }

    if (classType === bothGroups) {
        classes.push(inPersonClasses);
    }

    if (onlineType != "offline") {
        classes.push(onlineClasses);
    }

    return classes.flat();
};

export const typeClasses = [
    {
        label: "Private classes",
        value: "Private classes",
    },
    {
        label: "Group classes",
        value: "Group classes",
    },
    {
        label: "Private and Group classes",
        value: "Private and Group classes",
    },
];

export const onlineTypeClass = [{label: "Online", value: "online"}];

export const allClasses = [inPersonClasses, onlineClasses].flat();

export const privateGroup = "Private classes";
export const group = "Group classes";
export const bothGroups = "Private and Group classes";

export const defaultTypeClasses = {
    Group: {value: "Group", label: "Group"},
    Private: {value: "Private", label: "Private"},
};

export const defaultNumberOfStudents = {label: "1 student", value: 1};

export const classLists = [
    {
        label: "First class",
        value: "First class",
    },
    {
        label: "2 classes",
        value: "2 classes",
    },
    {
        label: "3 classes",
        value: "3 classes",
    },
    {
        label: "4 classes",
        value: "4 classes",
    },
];

export function checkTeacherSlotTypes(classes) {
    if (!classes) return {has_group: true, has_private: true};

    let hasPrivate = false;
    let hasGroup = false;

    for (const classDay of classes) {
        for (const timing of classDay.teacher_class_timings) {
            if (timing.type === "Private") hasPrivate = true;
            if (timing.type === "Group") hasGroup = true;
            if (hasPrivate && hasGroup) break;
        }
        if (hasPrivate && hasGroup) break;
    }

    return {
        has_group: hasGroup,
        has_private: hasPrivate,
    };
}

export const onlineTypeMap = {
    offline: "Offline",
    online: "Online",
    both: "Offline/Online"
};

